<template>
  <v-dialog
    transition="dialog-bottom-transition"
    persistent
    lazy
    scrollable
    :value="show"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :width="$store.state.common.largeDialogWidth"
    @input="(val) => $emit('update:show', val)"
  >
    <v-card>
      <v-card-title class="pb-0">
        <v-layout column>
          <v-layout align-center>
            <div class="headline">
              {{ $t('chooseVideoFormats') }}
              <span
                v-if="chosenFormats.length > 0"
              >&nbsp;({{ chosenFormats.length }})</span>
            </div>
            <v-btn
              class="ml-auto mr-0 my-0"
              flat
              icon
              data-cy="edit-overlay-data-dialog-abort-btn"
              :title="$t('close')"
              @click="onAborted()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <video-format-chooser
          :key="redrawCounter"
          ref="chooser"
          class="mx-3"
          :mandatory="mandatory"
          :original-video-file="originalVideoFile"
          :chosen-formats.sync="chosenFormats"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <btn-ok
          round
          icon="check"
          :title="$t('save')"
          data-cy="format-chooser-dialog-confirm-btn"
          @click="onChosen()"
        />
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BtnOk from '@/components/ButtonOk';
import VideoFormatChooser from '@/components/VideoFormatChooser';

export default {
  components: {
    BtnOk,
    VideoFormatChooser,
  },
  props: {
    show: {
      type: Boolean,
      required: false,
    },
    /**
     * Whether choosing a format is a required action or optional.
     *
     * This affects how options are presented and the exact wording.
     */
    mandatory: {
      type: Boolean,
      default: false,
    },
    originalVideoFile: {
      type: File,
      required: true,
    },
    /**
     * Last formats choice, synced only when dialog is confirmed.
     *
     * Used to remember last choice when dialog is reopened.
     */
    lastChosenTvFormats: {
      type: Array[Object],
      required: true,
    },
  },
  data() {
    return {
      chosenFormats: [],
      redrawCounter: 0,
    };
  },
  watch: {
    show: function (show) {
      if (show) {
        // Make sure the chooser-widget is restarted from scratch.
        // This e.g. ensures the playhead position is always correct.
        this.redrawCounter += 1;

        // Remember last selection.
        this.chosenFormats = this.lastChosenTvFormats;
      }
    },
  },
  methods: {
    reset() {
      this.chosenFormats = [];
    },
    onAborted() {
      this.reset();
      this.$emit('update:show', false);
      this.$emit('aborted');
    },
    onChosen() {
      this.$emit('update:show', false);
      this.$emit('chosen', this.chosenFormats);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/VideoFormatChooserDialog.vue